"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hash = void 0;
const base64_js_1 = require("base64-js");
/**
 * Creates a base64 encoded data hash. (SHA-512)
 */
function hash(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return base64_js_1.fromByteArray(new Uint8Array(yield crypto.subtle.digest('SHA-512', data)));
    });
}
exports.hash = hash;
//# sourceMappingURL=Hashing.js.map